export const Types = {
    GET_EXCEL_LIST: "GET_EXCEL_LIST",
    SET_EXCEL_LIST: "SET_EXCEL_LIST",
    LOCALIZATION_UPLOAD_FILE: "LOCALIZATION_UPLOAD_FILE",
    LOCALIZATION_EXCEL_FILE_OUTLINE: "LOCALIZATION_EXCEL_FILE_OUTLINE",
};

export const getExcelList = (payload) => ({
    type: Types.GET_EXCEL_LIST,
    payload,
});

export const setExcelList = (payload) => ({
    type: Types.SET_EXCEL_LIST,
    payload,
});

export const postExcelUpload = (payload) => ({
    type: Types.LOCALIZATION_UPLOAD_FILE,
    payload,
});

export const downloadExcelFile = (payload) => ({
    type: Types.LOCALIZATION_EXCEL_FILE_OUTLINE,
    payload,
});
